import { LoginService } from './../../../core/services/login.service';
import { Apollo, gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import { Filter } from 'src/app/core/models/filter';
import { combineLatest } from 'rxjs';
import { pluck } from 'rxjs/operators';
const suppliesOrdersSubscription = gql`query supplies_orders($andList: [supplies_orders_bool_exp!], $limit: Int, $offset: Int) {
  supplies_orders(where: {_and: $andList}, limit: $limit, offset: $offset, order_by:{order_number: desc}) {
    id
    created_at
    updated_at
    short_id
    supply_coupon_id
    total_amount
    tax_amount
    delivery_charge
    estimated_delivery_in_days
    status
    payment_status
    payment_mode
    billing_address
    shipping_address
    online_payment_order_id
    online_payment_transaction_id
    online_payment_signature
    approved_on
    approved_message
    shipped_on
    shipped_message
    delivered_on
    delivered_message
    cancelled_on
    canceled_message
    refunded_on
    refunded_message
    custom_message
    dental_practice_id
    dental_practice{
      id
      name
      phone
      email
    }
    dental_professional_id
    dental_professional{
      id
      name
      phone
      email
    }
    dental_supplier_id
    dental_supplier{
      id
      name
      phone
      email
    }
    account_pay_details
    suppliers_id
    coupon_discount
    sub_total
    order_number
    supplies_order_notes{
      id
      created_at
      updated_at
      supplies_order_id
      status
      message
    }
  }
}`;

const suppliesOrdersAggregateSubscription = gql`query supplies_orders_aggregate($andList: [supplies_orders_bool_exp!]){
  supplies_orders_aggregate(where:{_and: $andList}) {
    aggregate {
      count
    }
  }
}`;
@Injectable({
  providedIn: 'root'
})
export class GetSupplierOrdersService {

/* ------------------------------- Constructor ------------------------------ */
  constructor(
  private apollo: Apollo,
  private loginService: LoginService) { }

/* ------------------------------- Get Supply Orders ------------------------------- */
getSuppliesOrders(filter: Filter){
  const andList : any = [];

  if(filter.supplier_id){
    andList.push({
      suppliers_id: {_eq: filter.supplier_id }
    });
  }

  if(filter.status){
    andList.push({
      status : { _eq: filter.status }
    });
  } else {
    andList.push({
      status : { _neq: 'DRAFT' }
    });
  }

  if(filter.start && filter.end){
    andList.push({
      created_at : {_gte: filter.start, _lte: filter.end},
    });
  }



  const loginData = this.loginService.getLoginData();
  if(loginData.type === 'SUPPLIER'){
      andList.push({
        dental_supplier_id: { _eq: loginData.id}
      })
  }

  if(loginData.type === 'PRACTICE'){
    andList.push({
      dental_practice_id: { _eq: loginData.id}
    })
  }

  if(loginData.type === 'PROFESSIONAL'){
    andList.push({
      dental_professional_id : { _eq: loginData.id}
    })
  }

  return combineLatest([
    this.apollo.use('external').query({
     query: suppliesOrdersSubscription,
     fetchPolicy: "network-only",
     variables: {
       andList: andList,
       limit: filter.limit,
       offset: filter.offset
     }
    }).pipe(pluck('data', 'supplies_orders')),
    this.apollo.use('external').query({
      query: suppliesOrdersAggregateSubscription,
      fetchPolicy: "network-only",
      variables: {
        andList: andList
      }
    }).pipe(pluck('data', 'supplies_orders_aggregate', 'aggregate', 'count'))
  ]);
}
}
